import React from 'react';
import { Grid } from '@material-ui/core';
import { sanlamIndigo } from 'Material-UI/colors';
import { IntlShape, injectIntl } from 'react-intl';
import {
  BodyContainer,
  AbsoluteGrid,
  StyledSmallSectionHeader,
} from 'containers/CookiesPage/styles';
import messages from 'containers/CookiesPage/messages';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import ScrollBack from 'components/ButtonBackToTop';
const COOKIES = [
  {
    content: 'paragraph1',
  },
  {
    content: 'paragraph2',
  },
  {
    content: 'paragraph3',
  },
  {
    content: 'paragraph4',
  },
  {
    content: 'paragraph5',
  },
  {
    content: 'paragraph6',
  },
  {
    content: 'paragraph7',
  },
  {
    content: 'paragraph8',
  },
  {
    content: 'paragraph9',
  },
];

const Body = (props: { intl: IntlShape }) => {
  return (
    <Grid container alignItems="center" justify="center">
      <BodyContainer>
        <AbsoluteGrid>
          <ScrollBack showBelow={500} />
          <Grid container alignItems="center" justify="center">
            <Grid item xs>
              {COOKIES.map((item: { content: string }) => (
                <React.Fragment key={item.content}>
                  <StyledSmallSectionHeader color={sanlamIndigo} weight="100">
                    {translate(get(messages, item.content), props)}
                  </StyledSmallSectionHeader>
                </React.Fragment>
              ))}
            </Grid>
          </Grid>
        </AbsoluteGrid>
      </BodyContainer>
    </Grid>
  );
};
export default injectIntl(Body);
